<template>
  <div>
    <v-row>
      <span
        class="pa-3 white--text font-weight-bold text-uppercase text-h3 d-inline-block"
        >Collection</span
      >
    </v-row>
    <CollectionComponent />
  </div>
</template>

<script>
import CollectionComponent from "@/components/CollectionComponent.vue";

export default {
  name: "Leaderboard",
  components: {
    CollectionComponent
  }
};
</script>

<style scoped>
</style>